export const styles = {
  "header-container": ["text-black-me"].join(" "),
  svg: ["cursor-pointer", "fill-current"].join(" "),
  active_: ["active-toggle-menu"].join(" "),
  in_: ["animate-menu-in"].join(" "),
  out_: ["animate-menu-out"].join(" "),
};
